import { IonButton, IonIcon, IonSkeletonText, IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { CHOSEN_CORE_VALUES_LIMIT } from "@/lib/constants";
import { arrowRightIcon } from "@/lib/icons/@heroicons/react/16/solid";
import { queryOptions_coreValuesChosen } from "@/lib/query/functions/core-values/chosen";
import { useMyData } from "@/lib/query/functions/user/data";
import { Routes } from "@/lib/router";

export function PerfectDayWidget() {
	const { t } = useTranslation();
	const [myData] = useMyData();

	const queryCoreValues = useQuery(queryOptions_coreValuesChosen());

	const hasChosenCoreValues = (queryCoreValues.data?.length ?? 0) === CHOSEN_CORE_VALUES_LIMIT;

	if (queryCoreValues.isLoading) {
		return <IonSkeletonText animated className="h-42 rounded-3xl" />;
	}

	if (!hasChosenCoreValues || myData.perfectDay.hasCompleted) {
		return <></>;
	}

	return (
		<div className="bg-brown-100 flex flex-col gap-2 rounded-3xl p-4">
			<IonText className="text-brown-700 text-2xl font-bold">
				{t("widgets.perfect-day.title")}
			</IonText>
			<IonText className="text-brown-600">{t("widgets.perfect-day.description")}</IonText>

			<IonButton
				routerLink={Routes.PerfectDayDashboard()}
				className="ion-py-2.5 ion-rounded-lg min-h-10"
			>
				{t("widgets.perfect-day.action")}
				<IonIcon slot="end" icon={arrowRightIcon} className="ml-2 size-5 opacity-60" />
			</IonButton>
		</div>
	);
}
